<style scoped="scoped" lang="scss">
  .read_title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 36px;
    font-size: 16px;
    font-family: Microsoft YaHei UI;
    color: #303133;

  }
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/process/flowNode/page?nodeStatus=1" ref="yt" getKey="rows" :columns="columns">
      <!-- 类型 插槽-->
      <template #leixing="scope">
        {{$t(scope.row.flow.bizType)}}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiaoxiqiangqing', scope.row.flow,'1300px')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiaoxishenghe', scope.row.flow,'1300px',showAfter(scope.row))">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action === 'xiaoxiqiangqing'">
        <div class="dialog-scroller">
          <div style="width: 100%;height: 1px;border: 1px solid #E4E7ED;"></div>
          <div class="read_title">
            {{ this.yt.editObj.title }}
          </div>
          <!--内容-->
<!--          <div style="margin: 40px; color: #606266">
            {{ this.yt.editObj.bizMsg }}
          </div>-->
          <!-- 申请时间，申请人 -->
          <div style="display: flex;flex-wrap: nowrap;color: #606266;justify-content: center;align-items: center;margin-top: 18px">
            <span> {{ $t('shenqingren') }}: {{ this.yt.editObj.promoterName }} </span>
            <span style="margin-left: 30px"> {{ $t('shenqingshijian') }}:{{dayjs(this.yt.editObj.promoterTime).format('YYYY-MM-DD HH:mm')}} </span>
            <span style="margin-left: 30px"> {{$t('chulijieguo') }}: {{ getApprovalStatusDesc(this.yt.editObj.approvalStatus) }} </span>
          </div>

          <div>
            <see-adjusting ref="seeAdjustingRef" @dialogClose="yt.isShowEditDialog = false" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.bizId"></see-adjusting>
          </div>
        </div>
      </template>
      <template v-if="yt.editObj.action ==='xiaoxishenghe'">
        <div class="dialog-scroller">
          <div style="width: 100%;height: 1px;border: 1px solid #E4E7ED;"></div>
          <div class="read_title">
            {{ this.yt.editObj.title }}
          </div>
          <!--内容-->
          <!--          <div style="margin: 40px; color: #606266">
                      {{ this.yt.editObj.bizMsg }}
                    </div>-->
          <!-- 申请时间，申请人 -->
          <div style="display: flex;flex-wrap: nowrap;color: #606266;justify-content: center;align-items: center;margin-top: 18px">
            <span> {{ $t('shenqingren') }}: {{ this.yt.editObj.promoterName }} </span>
            <span style="margin-left: 30px"> {{ $t('shenqingshijian') }}:{{dayjs(this.yt.editObj.promoterTime).format('YYYY-MM-DD HH:mm')}} </span>
            <span style="margin-left: 30px"> {{$t('chulijieguo') }}: {{ getApprovalStatusDesc(this.yt.editObj.approvalStatus) }} </span>
          </div>

          <el-form :model="yt.editObj" label-width="auto"  ref="ruleForm">
            <el-form-item :label="$t('chulijieguo')" required>
                <el-radio-group v-model="formData.approvalStatus" >
                  <el-radio  label="1">{{ $t('tongguo')}}</el-radio>
                  <el-radio  label="2">{{ $t('butongguo')}}</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="formData.remark"></el-input>
            </el-form-item>
          </el-form>
          <div>
            <see-adjusting ref="seeAdjustingRef" @dialogClose="yt.isShowEditDialog = false" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.bizId"></see-adjusting>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="check()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  import seeAdjusting from '@@/pages/web/process_distribution/adjusting_record/see_adjusting.vue';
  export default {
    name: 'web_system_process_chcek_pending',
    components: {
      seeAdjusting
    },
    data() {
      return {
        formData: {
          id: '',
          flowId: '',
          approvalStatus: '',
          remark: ''
        },
        columns: [
          {
            label: 'leixing',
            type: 'slot',
            width: 120
          },
          {
            label: 'xiaoxibiaoti',
            prop: 'flow.title',
          },
          {
            label: 'miaoshu',
            prop: 'flow.bizMsg',
          },
          {
            label: 'shenqingshijian',
            prop: 'flow.promoterTime',
            type: 'time',
          }, {
            label: 'shenqingren',
            prop: 'flow.promoterName',
            fixed: 'right'
          }, {
            label: 'caozuo',
            type: 'slot',
            fixed: 'right'
          }
        ],
      }
    }, methods: {
      check() {
        this.http.post('/web/process/flowNode/flowCheck', this.formData).then(response => {
          this.$message.success(this.$t('chenggong'));
          this.yt.get(1)
        }).finally(() => {
          this.yt.isShowEditDialog = false
        })

      },
      showAfter(params) {
        this.formData.id = params.id
        this.formData.flowId = params.flow.id
        this.formData.approvalStatus = '1'
        console.log('params', this.formData)
      },
      getApprovalStatusDesc(status) {
        switch (status) {
          case '0':
            return '审批中';
          case '1':
            return '审批通过';
          case '2':
            return '审批不通过';
          case '3':
            return '撤回';
        }
      },
      searchBtn() {
        this.yt.get(1);
      },
      clear() {
        this.conditions.approvalStatus = null,
            this.yt.conditions = this.conditions
        this.yt.get(1)
      },
    }, created() {
      setTimeout(() => {
        this.yt.conditions = {
          orderBy: 'id desc',
        };
        this.yt.get(1)
      }, 300)
    }
  }
</script>
